/* eslint-disable prefer-promise-reject-errors */
import config from 'src/config';
import { postRequest } from 'src/utils/RequestUtil';

export const zoneSearchAPI = function (data) {
    const url = `${config.baseUrl}zone/search`;
    return postRequest({
        url,
        data,
    });
};

export default {
    zoneSearchAPI,
};
